'use client';

import dynamic from 'next/dynamic';

const Page = dynamic(() => import('@/components/default/views/page/Page'), { ssr: false });

interface PageProps {
    slug: string;
}

export default function DynamicViewPage({ slug }: PageProps) {
    return <Page slug={slug} />;
}
